(function () {
 
  document.addEventListener('DOMContentLoaded', () => {
    const headers = document.querySelectorAll('.antla-popup-header');

    
    headers.forEach(header => {
      header.innerHTML = "One of a kin Try on";
    });

    const breadcrumbLinks = document.querySelectorAll('.breadcrumbs a');
    let collectionClass = '';

    breadcrumbLinks.forEach(link => {
    
      if (link.title.toLowerCase() === 'women') {
        collectionClass = 'women';
      } else if (link.title.toLowerCase() === 'men') {
        collectionClass = 'men';
      } else if (link.title.toLowerCase() === 'boys') {
        collectionClass = 'boys';
      }else if (link.title.toLowerCase() === 'girls') {
        collectionClass = 'girls';
      }
    });

    
    const PRESET_IMAGES = collectionClass === 'women' ? [
      {
        label: "Model 1",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Woman_plus_size_800x800.png?v=1770983651",
      },
      {
        label: "Model 2",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Woman_skinny_800x800.png?v=1770983651",
      },
      {
        label: "Model 3",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Woman_standard_800x800.png?v=1770983651",
      },
    ] : collectionClass === 'men' ? [
      {
        label: "Model 1",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Men_plus_size_800x800.png?v=1770981953",
      },
      {
        label: "Model 2",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Men_skinny_800x800.png?v=1770983651",
      },
      {
        label: "Model 3",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Men_standard_800x800.png?v=1770983651",
      },
    ] : collectionClass === 'boys' ? [
      {
        label: "Model 1",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Boy_plus_size_800x800.png?v=1770983651",
      },
      {
        label: "Model 2",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Boy_skinny_800x800.png?v=1770983651",
      },
      {
        label: "Model 3",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Boy_standard_800x800.png?v=1770983651",
      },
    ]: collectionClass === 'girls' ? [
      {
        label: "Model 1",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Girl_plus_size_800x800.png?v=1770973915",
      },
      {
        label: "Model 2",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Girl_skinny_800x800.png?v=1770983651",
      },
      {
        label: "Model 3",
        url: "https://cdn.shopify.com/s/files/1/0574/4171/4259/files/Girl_standard_800x800.png?v=1770983651",
      },
    ]: [];

    let draggedPresetUrl = null;

    async function setAntlaFileFromUrl(popup, url) {
      const uploadBtn = popup.querySelector("#upload-image-button");
      if (uploadBtn) {
        uploadBtn.click();
      }

      await new Promise(r => setTimeout(r, 80));

      const input = popup.querySelector("#antla-uploadInput");
      if (!input) return;

      const res = await fetch(url, { cache: "no-cache" });
      const blob = await res.blob();

      const ext = (blob.type && blob.type.split("/")[1]) || "jpg";
      const file = new File([blob], `antla-preset.${ext}`, {
        type: blob.type || "image/jpeg",
      });

      const dt = new DataTransfer();
      dt.items.add(file);

      input.files = dt.files;

      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    function injectPresetsIntoPopup() {
      const popup = document.querySelector(".antla-popup.antla-popup-v2");
      if (!popup) return;

      const dropArea = popup.querySelector(".antla-file-drop-area");
      if (!dropArea) return;

     
      if (popup.querySelector("[data-antla-presets]")) return;

     
      const infoText = document.createElement("p");
      infoText.textContent = "Or pick one of the below models";
      infoText.style.cssText = `
        text-align: center;
        font-size: 14px;
        margin: 10px 0;
        color: #333;
      `;

      const presetContainer = document.createElement("div");
      presetContainer.classList.add("preset-images-container"); 
      presetContainer.appendChild(infoText);

    
      const bar = document.createElement("div");
      bar.setAttribute("data-antla-presets", "1");
      bar.style.cssText = `
        display: flex;
        gap: 12px;
        padding: 12px;
        justify-content: center;
        border-top: 1px dashed rgba(0,0,0,0.15);
        background: #fafafa;
        margin-top: 10px;
      `;

      PRESET_IMAGES.forEach((img) => {
        const wrap = document.createElement("div");
        wrap.style.cssText = `display:flex;flex-direction:column;align-items:center;gap:6px;`;

        const thumb = document.createElement("img");
        thumb.src = img.url;
        thumb.alt = img.label;
        thumb.draggable = true;

        thumb.style.cssText = `
          width: 70px;
          height: 250px;
          object-fit: cover;
          border-radius: 10px;
          cursor: grab;
          border: 1px solid rgba(0,0,0,0.15);
          background:#fff;
        `;

        thumb.addEventListener("dragstart", (e) => {
          draggedPresetUrl = img.url;
          try {
            e.dataTransfer.setData("text/plain", img.url);
          } catch (_) {}
        });

        thumb.addEventListener("click", async () => {
          try {
            await setAntlaFileFromUrl(popup, img.url);
          } catch (err) {
            console.error("Antla preset click upload failed:", err);
          }
        });

        const label = document.createElement("div");
        label.textContent = "Use";
        label.style.cssText = `
          font-size: 12px;
          opacity: 0.7;
        `;

        wrap.appendChild(thumb);
        wrap.appendChild(label);
        bar.appendChild(wrap);
      });

      presetContainer.appendChild(bar);
      dropArea.insertAdjacentElement("afterend", presetContainer); 
    }

    const observer = new MutationObserver(injectPresetsIntoPopup);
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("DOMContentLoaded", injectPresetsIntoPopup);
  });
})();
